import { Navigate, useRoutes } from "react-router-dom";
// layouts
import DashboardLayout from "./layouts/dashboard";
import LogoOnlyLayout from "./layouts/LogoOnlyLayout";
//
import HomePage from "./pages/HomePage";
import ComplaintPage from "./pages/ComplaintPage";
import ComplaintConfirmPage from "./pages/ComplaintConfirmPage";

import ClientDashboardPage from "./pages/ClientDashboardPage";
import ClientSearchPage from "./pages/ClientSearchPage";
import ClientLoginPage from "./pages/ClientLoginPage";
import ClientRegisterPage from "./pages/ClientRegisterPage";

import ClientPasswordCode from "./pages/ClientPasswordCode";
import ClientPasswordForgot from "./pages/ClientPasswordForgot";
import ClientPasswordChange from "./pages/ClientPasswordChange";

import ClientRegisterConfirmPage from "./pages/ClientRegisterConfirmPage";
import ComplaintClientPage from "./pages/ComplaintClientPage";
import ClientComplaintViewPage from "./pages/ClientComplaintViewPage";
import ComplaintClientConfirmPage from "./pages/ComplaintClientConfirmPage";
import ClientLoginLoadInfo from "./pages/ClientLoginLoadInfo";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminLoginLoadInfo from "./pages/AdminLoginLoadInfo";
import AdminRegisterPage from "./pages/AdminRegisterPage";

import AdminEmailChange from "./pages/AdminEmailChange";
import AdminPasswordChange from "./pages/AdminPasswordChange";
import AdminPasswordForgot from "./pages/AdminPasswordForgot";
import AdminPasswordCode from "./pages/AdminPasswordCode";

import AdminRegisterConfirmPage from "./pages/AdminRegisterConfirmPage";
import AdminComplaintListPage from "./pages/AdminComplaintListPage";
import AdminComplaintViewPage from "./pages/AdminComplaintViewPage";

import AdmimConformitePage from "./pages/AdmimConformitePage";
import AdmimConformiteAddPage from "./pages/AdmimConformiteAddPage";
import AdmimConformiteEditPage from "./pages/AdmimConformiteEditPage";
import AdmimConformiteDeletePage from "./pages/AdmimConformiteDeletePage";

import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminProducts from "./pages/AdminProducts";
import AdminBlog from "./pages/AdminBlog";
import AdminUser from "./pages/AdminUser";
import Page401 from "./pages/Page401";
import Page404 from "./pages/Page404";
import Page405 from "./pages/Page405";
import Page401Admin from "./pages/Page401Admin";
import Page404Admin from "./pages/Page404Admin";
import Page405Admin from "./pages/Page405Admin";

import { ROLES } from "./redux/auth/auth.actions";

import PrivateRoute from "./PrivateRoute";

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: "/dashboard",
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" replace /> },
        {
          path: "app",
          element: (
            <AdminDashboardPage />
          ),
        },
        {
          path: "email-change",
          element: <PrivateRoute roles={ROLES.ADMIN} component={AdminEmailChange} />,
        },
        {
          path: "password-change",
          element: <PrivateRoute roles={ROLES.ADMIN} component={AdminPasswordChange} />,
        },
        {
          path: "user",
          element: <PrivateRoute roles={ROLES.ADMIN} component={AdminUser} />,
        },
        {
          path: "products",
          element: (
            <PrivateRoute roles={ROLES.ADMIN} component={AdminProducts} />
          ),
        },
        {
          path: "blog",
          element: <PrivateRoute roles={ROLES.ADMIN} component={AdminBlog} />,
        },
        {
          path: "admin-complaint-view/:confirmationId",
          element: (
            <PrivateRoute
              roles={ROLES.ADMIN}
              component={AdminComplaintViewPage}
            />
          ),
        },
        {
          path: "admin-complaints",
          element: (
            <PrivateRoute
              roles={ROLES.ADMIN}
              component={AdminComplaintListPage}
            />
          ),
        },
        {
          path: "admin-conformites",
          element: (
            <PrivateRoute roles={ROLES.ADMIN} component={AdmimConformitePage} />
          ),
        },
        {
          path: "admin-conformites-add",
          element: (
            <PrivateRoute
              roles={ROLES.ADMIN}
              component={AdmimConformiteAddPage}
            />
          ),
        },
        {
          path: "admin-conformites-edit",
          element: (
            <PrivateRoute
              roles={ROLES.ADMIN}
              component={AdmimConformiteEditPage}
            />
          ),
        },
        {
          path: "admin-conformites-delete",
          element: (
            <PrivateRoute
              roles={ROLES.ADMIN}
              component={AdmimConformiteDeletePage}
            />
          ),
        },
      ],
    },
    {
      path: "/",
      element: <LogoOnlyLayout />,
      children: [
        {
          path: "client-dashboard",
          element: <ClientDashboardPage />
        },
        {
          path: "complaint-view/:confirmationId",
          element: (
            <PrivateRoute
              roles={ROLES.CLIENT}
              component={ClientComplaintViewPage}
            />
          ),
        },
        { path: "complaint-client", element: <ComplaintClientPage /> },
        {
          path: "complaint-client-confirm",
          element: <ComplaintClientConfirmPage />,
        },
        { path: "complaint", element: <ComplaintPage /> },
        { path: "complaint-confirm", element: <ComplaintConfirmPage /> },
        { path: "admin", element: <AdminLoginPage /> },
        { path: "admin-proccess", element: <AdminLoginLoadInfo /> },
        { path: "admin-register", element: <AdminRegisterPage /> },
        { path: "admin-password-forgot", element: <AdminPasswordForgot /> },
        { path: "admin-password-code", element: <AdminPasswordCode /> },


        {
          path: "admin-register-confirm",
          element: <AdminRegisterConfirmPage />,
        },
        { path: "login", element: <ClientLoginPage /> },
        { path: "login-proccess", element: <ClientLoginLoadInfo /> },
        { path: "login-password-forgot", element: <ClientPasswordForgot /> },
        { path: "login-password-code", element: <ClientPasswordCode /> },
        { path: "login-password-change", element: <ClientPasswordChange /> },
        { path: "register", element: <ClientRegisterPage /> },
        { path: "register-confirm", element: <ClientRegisterConfirmPage /> },
        { path: "home", element: <HomePage /> },
        { path: "search", element: <ClientSearchPage /> },
        { path: "401-admin", element: <Page401Admin /> },
        { path: "404-admin", element: <Page404Admin /> },
        { path: "405-admin", element: <Page405Admin /> },
        { path: "401", element: <Page401 /> },
        { path: "404", element: <Page404 /> },
        { path: "405", element: <Page405 /> },
        { path: "/", element: <Navigate to="/home" /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
